<template>
  <div class="gb-select-area">
    <el-cascader
      ref="cascaderRef"
      v-model="syncedValue" :options="pcaTextArr"
      clearable @change="handleChange" />
  </div>
</template>

<script>
import { pcaTextArr } from 'element-china-area-data'

/** GbSelectArea组件说明
 * 省市区选择器
*/
export default {
  name: 'GbSelectArea',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    // 收集参数对象
    collectParamsObj: {
      type: Object,
      // required: true
    },
  },
  data() {
    return {
      pcaTextArr
    }
  },
  computed: {
    syncedValue: {
      get() {
        return this.value;
      },
      set(vals) {
        this.$emit('input', vals);
      }
    }
  },
  methods: {
    handleChange(vals) {
      // console.log('vals', vals);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/global/YxGbSelectArea/index.vue